import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNavAgentCenterFill = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: "1em",
	viewBox: "0 -960 960 960",
	width: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(0,-960) scale(40)",
		children: /* @__PURE__ */ _jsx("path", { d: "M11.9998 4.54877C15.1348 2.85379 18.1711 2.61464 19.7781 4.22162C21.385 5.8286 21.1448 8.86414 19.45 11.999C21.1451 15.134 21.3851 18.1702 19.7781 19.7773C18.171 21.3842 15.1349 21.1443 11.9998 19.4492C8.86491 21.1441 5.82948 21.3842 4.22247 19.7773C2.61544 18.1702 2.85451 15.134 4.54962 11.999C2.85483 8.86411 2.61554 5.82758 4.22247 4.22064C5.82951 2.61422 8.86529 2.85419 11.9998 4.54877ZM10.7889 10.789L7.99982 11.9999L10.7889 13.2109L11.9998 15.9999L13.2108 13.2109L15.9998 11.9999L13.2108 10.789L11.9998 7.99994L10.7889 10.789Z" })
	})
});
export default SvgNavAgentCenterFill;
